function getRpcPath(method) {
  return `/services/${method.parent.fullName}/${method.name}`;
}
function getRpcPathFromStrings(service, method) {
  return `/services/${service}/${method}`;
}
function absolutize(url) {
  if (url[0] === "/") {
    const { protocol, host } = window.location;
    return `${protocol}//${host}${url}`;
  }
  return url;
}

export { absolutize as a, getRpcPath as b, getRpcPathFromStrings as g };
